import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PointCloudIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12.5 2H11.5C11.1548 2 10.875 2.27982 10.875 2.625V3.625C10.875 3.97018 11.1548 4.25 11.5 4.25H12.5C12.8452 4.25 13.125 3.97018 13.125 3.625V2.625C13.125 2.27982 12.8452 2 12.5 2Z"
        fill={color}
      />
      <path
        d="M12.5 7.91699H11.5C11.1548 7.91699 10.875 8.19681 10.875 8.54199V9.54199C10.875 9.88717 11.1548 10.167 11.5 10.167H12.5C12.8452 10.167 13.125 9.88717 13.125 9.54199V8.54199C13.125 8.19681 12.8452 7.91699 12.5 7.91699Z"
        fill={color}
      />
      <path
        d="M5.84399 4.21899H4.84399C4.49882 4.21899 4.21899 4.49882 4.21899 4.84399V5.84399C4.21899 6.18917 4.49882 6.46899 4.84399 6.46899H5.84399C6.18917 6.46899 6.46899 6.18917 6.46899 5.84399V4.84399C6.46899 4.49882 6.18917 4.21899 5.84399 4.21899Z"
        fill={color}
      />
      <path
        d="M19.156 4.21899H18.156C17.8108 4.21899 17.531 4.49882 17.531 4.84399V5.84399C17.531 6.18917 17.8108 6.46899 18.156 6.46899H19.156C19.5012 6.46899 19.781 6.18917 19.781 5.84399V4.84399C19.781 4.49882 19.5012 4.21899 19.156 4.21899Z"
        fill={color}
      />
      <path
        d="M5.84399 17.531H4.84399C4.49882 17.531 4.21899 17.8108 4.21899 18.156V19.156C4.21899 19.5012 4.49882 19.781 4.84399 19.781H5.84399C6.18917 19.781 6.46899 19.5012 6.46899 19.156V18.156C6.46899 17.8108 6.18917 17.531 5.84399 17.531Z"
        fill={color}
      />
      <path
        d="M19.156 17.531H18.156C17.8108 17.531 17.531 17.8108 17.531 18.156V19.156C17.531 19.5012 17.8108 19.781 18.156 19.781H19.156C19.5012 19.781 19.781 19.5012 19.781 19.156V18.156C19.781 17.8108 19.5012 17.531 19.156 17.531Z"
        fill={color}
      />
      <path
        d="M15.458 10.875H14.458C14.1128 10.875 13.833 11.1548 13.833 11.5V12.5C13.833 12.8452 14.1128 13.125 14.458 13.125H15.458C15.8032 13.125 16.083 12.8452 16.083 12.5V11.5C16.083 11.1548 15.8032 10.875 15.458 10.875Z"
        fill={color}
      />
      <path
        d="M12.5 19.75H11.5C11.1548 19.75 10.875 20.0298 10.875 20.375V21.375C10.875 21.7202 11.1548 22 11.5 22H12.5C12.8452 22 13.125 21.7202 13.125 21.375V20.375C13.125 20.0298 12.8452 19.75 12.5 19.75Z"
        fill={color}
      />
      <path
        d="M12.5 13.833H11.5C11.1548 13.833 10.875 14.1128 10.875 14.458V15.458C10.875 15.8032 11.1548 16.083 11.5 16.083H12.5C12.8452 16.083 13.125 15.8032 13.125 15.458V14.458C13.125 14.1128 12.8452 13.833 12.5 13.833Z"
        fill={color}
      />
      <path
        d="M21.375 10.875H20.375C20.0298 10.875 19.75 11.1548 19.75 11.5V12.5C19.75 12.8452 20.0298 13.125 20.375 13.125H21.375C21.7202 13.125 22 12.8452 22 12.5V11.5C22 11.1548 21.7202 10.875 21.375 10.875Z"
        fill={color}
      />
      <path
        d="M3.625 10.875H2.625C2.27982 10.875 2 11.1548 2 11.5V12.5C2 12.8452 2.27982 13.125 2.625 13.125H3.625C3.97018 13.125 4.25 12.8452 4.25 12.5V11.5C4.25 11.1548 3.97018 10.875 3.625 10.875Z"
        fill={color}
      />
      <path
        d="M9.54199 10.875H8.54199C8.19681 10.875 7.91699 11.1548 7.91699 11.5V12.5C7.91699 12.8452 8.19681 13.125 8.54199 13.125H9.54199C9.88717 13.125 10.167 12.8452 10.167 12.5V11.5C10.167 11.1548 9.88717 10.875 9.54199 10.875Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PointCloudIcon.displayName = 'PointCloudIcon';
